import { Header } from "../../header/Header";
import missionImage from "../../assets/mission.jpeg";
import visionImage from "../../assets/vision.jpeg";
import nalini from "../../assets/nalini.jpeg";
import sunita from "../../assets/sunita.jpeg";
import shekhar from "../../assets/shekhar.jpeg";
import sonali from "../../assets/sonali.jpeg";
import bhushan from "../../assets/bhushan.jpeg";
import neha from "../../assets/neha.jpeg";
import arvind from "../../assets/arvind.jpeg";
import rashmi from "../../assets/rashmi.jpeg";
import gourav from "../../assets/gourav.jpeg";
import varsha from "../../assets/varsha.jpeg";
import a1 from "../../assets/a1.jpg";
import a2 from "../../assets/a2.png";
import a3 from "../../assets/a3.jpg";
import { Footer } from "../footer/Footer";

export const About = () => {
  const teamMembers = [
    {
      name: "Ms. Nalini Sakat",
      title: "Child Psychologist/ Special Educator",
      role: "Counselling Psychologist",
      image: nalini,
    },
    {
      name: "Ms. Sunita Pandey",
      title: "Counselling Psychologist",
      role: "Psychotherapist",
      image: sunita,
    },
    {
      name: "Mr. Shekhar Patil",
      title: "Special Educator",
      role: "Occupational Therapist",
      image: shekhar,
    },
    {
      name: "Mr. Arvind Sonwane",
      title: "B.Ed (H.I) Speech Therapist",
      role: "19+ Years of Experience",
      image: arvind,
    },
    {
      name: "Mrs. Rashmi Pawar",
      title: "Counselling Psychologist",
      role: "/ Psychotherapist",
      image: rashmi,
    },
    {
      name: "Mrs. Sonali Jadhav",
      title: "Clinical Psychologist",
      role: "We conduct IQ test, EQ test, Personality test, career testing.",
      image: sonali,
    },
    {
      name: "Mr. Bhushan Honrao",
      title: "M.Phill in Clinical Psychology",
      role: "Psychological Assessment (WISC,WAPIS,MISIC,BKT and so on…)",
      image: bhushan,
    },
    {
      name: "Ms. Neha Joshi",
      title: "M.Phil. Clinical Psychology",
      role: "",
      image: neha,
    },
  ];

  const collaborators = [
    {
      name: "Dr. Gourav Trivedi",
      title: "Psychiatrist",
      image: gourav,
    },
    {
      name: "Dr. Varsha Dawani",
      title: "Psychiatrist",
      image: varsha,
    },
  ];

  return (
    <>
      <Header />

      {/* Page hero */}
      <section className="relative overflow-hidden bg-gradient-to-br from-brand-900 via-brand-800 to-sea-800 py-20 sm:py-28">
        <div className="pointer-events-none absolute -left-20 top-0 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-sea-400/20 blur-3xl" />
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-200">
            Who We Are
          </span>
          <h1 className="mt-4 font-display text-5xl font-semibold text-white sm:text-6xl">
            About Us
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-blue-100">
            A safe, compassionate space for healing, growth, and meaningful
            change.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <div className="relative mx-auto w-full max-w-lg">
            <div className="absolute inset-0 -rotate-2 rounded-[2rem] bg-brand-100" />
            <img
              src={missionImage}
              alt="Mission"
              className="relative w-full rounded-[2rem] object-cover shadow-soft"
            />
          </div>
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600">
              Our Purpose
            </span>
            <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900">
              Mission
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-600">
              Our aim is to provide compassionate and culturally sensitive
              counseling services to individuals of all age groups, any
              background, and abilities. Here we foster a safe and
              nonjudgmental environment that promotes self-exploration,
              personal insights, and self-awareness. We utilize evidence-based
              approaches and psychological interventions to address a wide
              range of psychological, emotional, and behavioral concerns. Our
              team conducts ongoing research to contribute to the advancement
              of counseling psychology and enhance the quality of treatment.
            </p>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="bg-gradient-to-br from-brand-50/70 to-sea-50/70 py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <div className="order-2 lg:order-1">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-sea-600">
              Where We're Headed
            </span>
            <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900">
              Vision
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-600">
              To empower individuals, families, and communities to achieve
              emotional well-being, personal growth, and meaningful
              relationships through evidence-based counseling interventions,
              advocacy, therapeutic approaches and holistic support. In Happy
              Faces, we strive for continuous professional development and
              adherence to ethical guidelines, ensuring the highest standards
              of competence and integrity for delivering our services.
            </p>
          </div>
          <div className="relative order-1 mx-auto w-full max-w-lg lg:order-2">
            <div className="absolute inset-0 rotate-2 rounded-[2rem] bg-sea-100" />
            <img
              src={visionImage}
              alt="Vision"
              className="relative w-full rounded-[2rem] object-cover shadow-soft"
            />
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto mb-14 max-w-3xl text-center">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600">
              Meet The Experts
            </span>
            <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900 sm:text-5xl">
              Our Team
            </h2>
            <p className="mt-4 text-lg italic text-slate-600">
              Your mind is powerful thing. When you start to filter it with
              positive thoughts your life will start to change.
            </p>
          </div>
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="group rounded-3xl border border-slate-100 bg-white p-6 text-center shadow-card transition-all duration-300 hover:-translate-y-2 hover:shadow-soft"
              >
                <div className="relative mx-auto h-32 w-32">
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-brand-400 to-sea-400 opacity-0 blur transition-opacity duration-300 group-hover:opacity-60" />
                  <img
                    src={member.image}
                    alt={member.name}
                    className="relative h-32 w-32 rounded-full border-4 border-brand-50 object-cover"
                  />
                </div>
                <h3 className="mt-5 text-lg font-bold text-slate-900">
                  {member.name}
                </h3>
                <p className="mt-1 text-sm font-semibold text-brand-700">
                  {member.title}
                </p>
                {member.role && (
                  <p className="mt-2 text-sm leading-relaxed text-slate-500">
                    {member.role}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Collaboration */}
      <section className="bg-gradient-to-br from-brand-50/70 to-sea-50/70 py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto mb-14 max-w-2xl text-center">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-sea-600">
              Trusted Partners
            </span>
            <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900 sm:text-5xl">
              Collaboration With
            </h2>
          </div>
          <div className="mx-auto grid max-w-2xl gap-8 sm:grid-cols-2">
            {collaborators.map((person, index) => (
              <div
                key={index}
                className="rounded-3xl border border-slate-100 bg-white p-8 text-center shadow-card transition-all duration-300 hover:-translate-y-2 hover:shadow-soft"
              >
                <img
                  src={person.image}
                  alt={person.name}
                  className="mx-auto h-36 w-36 rounded-full border-4 border-sea-50 object-cover"
                />
                <h3 className="mt-5 text-xl font-bold text-slate-900">
                  {person.name}
                </h3>
                <p className="mt-1 font-semibold text-sea-600">{person.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Help / CTA */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="font-display text-4xl font-semibold text-slate-900 sm:text-5xl">
            We are here to help you...
          </h2>
          <a
            href="/contact"
            className="mt-8 inline-block rounded-full bg-brand-700 px-10 py-4 text-sm font-bold tracking-widest text-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:bg-brand-800 hover:shadow-xl"
          >
            GETTING STARTED
          </a>
          <div className="mt-14 grid items-center gap-6 sm:grid-cols-3">
            <img
              src={a1}
              alt="Therapy session"
              className="h-64 w-full rounded-3xl object-cover shadow-card transition-transform duration-300 hover:scale-[1.02]"
            />
            <img
              src={a2}
              alt="Happy client"
              className="h-72 w-full rounded-3xl object-cover shadow-soft transition-transform duration-300 hover:scale-[1.02]"
            />
            <img
              src={a3}
              alt="Counseling"
              className="h-64 w-full rounded-3xl object-cover shadow-card transition-transform duration-300 hover:scale-[1.02]"
            />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};
